import i18n from 'i18next'
import fi from './locales/fi.json'
import en from './locales/en.json'
import {fi as reportQueueFi, en as reportQueueEn} from './locales/reportQueue'
import { initReactI18next } from 'react-i18next'

i18n
  .use(initReactI18next)
  .init({
    // Ship copy with the content-hashed application bundle, never stale HTTP JSON.
    resources: { fi: { translation: {...fi, reportQueue: reportQueueFi} }, en: { translation: {...en, reportQueue: reportQueueEn} } },
    debug: false,
    lng:'fi',
    fallbackLng: 'fi',
    supportedLngs: ['fi', 'en'],
    load: 'languageOnly',
    //keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      wait: true
    }
  })

export default i18n
